/**
 * Format a date as a relative time string (e.g., "3 days ago", "Last updated yesterday")
 * @param date - The date to format (ISO string or Date object)
 * @returns Formatted relative time string
 */
export const formatRelativeDate = (date: string | Date | null | undefined): string => {
  if (!date) return "Never updated";

  const dateObj = typeof date === "string" ? new Date(date) : date;
  const now = new Date();
  const diffInMs = now.getTime() - dateObj.getTime();
  const diffInDays = Math.floor(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays === 0) {
    const diffInHours = Math.floor(diffInMs / (1000 * 60 * 60));
    if (diffInHours === 0) {
      const diffInMinutes = Math.floor(diffInMs / (1000 * 60));
      if (diffInMinutes === 0) {
        return "Just now";
      }
      return `${diffInMinutes} minute${diffInMinutes === 1 ? "" : "s"} ago`;
    }
    return `${diffInHours} hour${diffInHours === 1 ? "" : "s"} ago`;
  }

  if (diffInDays === 1) {
    return "Last updated yesterday";
  }

  if (diffInDays < 7) {
    return `Last updated ${diffInDays} days ago`;
  }

  if (diffInDays < 30) {
    const weeks = Math.floor(diffInDays / 7);
    return `Last updated ${weeks} week${weeks === 1 ? "" : "s"} ago`;
  }

  if (diffInDays < 365) {
    const months = Math.floor(diffInDays / 30);
    return `Last updated ${months} month${months === 1 ? "" : "s"} ago`;
  }

  const years = Math.floor(diffInDays / 365);
  return `Last updated ${years} year${years === 1 ? "" : "s"} ago`;
};
